"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'weChatAdBase',
  components: {},
  data: function data() {
    return {
      list: [],
      listLoading: true,
      adType: {
        1: 'Banner广告',
        2: '激励视频广告',
        3: '插屏广告',
        4: '视频广告',
        5: '视频前贴广告',
        6: '封面广告',
        7: '原生模板广告'
      },
      adDialog: false,
      form: {},
      form_key: {
        wx_ads_closing: 0,
        user_direct_login: 1,
        user_expired_hours: 24,
        wx_ads_loading_seconds: 5
      }
    };
  },
  computed: {
    siteInfo: function siteInfo() {
      return this.$store.state.user.siteInfo;
    }
  },
  mounted: function mounted() {
    var f = [{
      "id": "1",
      "title": "主页",
      "path": "home",
      "file_path": "",
      "is_show": "1",
      "pid": "0",
      "icon": "",
      "status": "1",
      "hidden": false
    }, {
      "id": "2",
      "title": "主页",
      "path": "home",
      "file_path": "/home/home",
      "is_show": "1",
      "pid": "1",
      "icon": "",
      "status": "1",
      "props": "",
      "hidden": false
    }, {
      "id": "4",
      "title": "统计",
      "path": "tongji",
      "file_path": "/home/tongji",
      "is_show": "1",
      "pid": "2",
      "icon": "",
      "status": "1",
      "props": "",
      "hidden": false
    }, {
      "id": "3",
      "title": "登录",
      "path": "login/:gid?",
      "file_path": "/login/index",
      "is_show": "1",
      "pid": "0",
      "icon": "",
      "status": "1",
      "props": "",
      "hidden": true
    }];
    this.getList();
    if (this.siteInfo.wx_ad_right == 0 && this.checkRoles(['partner'])) this.getPayCode();
  },
  methods: {
    /**
     * 显示dialog
     */
    setAdDialog: function setAdDialog() {
      var params = {};
      for (var i in this.form_key) {
        params[i] = this.siteInfo[i];
      }
      this.form = params;
      this.adDialog = true;
    },
    /**
     * 获取广告位置
     */
    getList: function getList() {
      var _this = this;
      var url = 'agentapi/ad/get_wx_ad_positions';
      this.$get(url).then(function (res) {
        _this.listLoading = false;
        _this.list = Object.values(res);
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 设置是否显示
     */
    setShow: function setShow(row) {
      var _this2 = this;
      var is_show = row.is_show == 1 ? 0 : 1;
      this.$post('agentapi/ad/save_wx_ad_positions_permission', {
        business_type: row.business_type,
        is_show: is_show
      }).then(function (res) {
        _this2.$message({
          message: '设置成功',
          type: 'success'
        });
        row.is_show = is_show;
      });
    },
    /**
     * 获取开通广告支付二维码
     */
    getPayCode: function getPayCode() {
      this.$get('agentapi/pay/get_wxad_contract_qrcode').then(function (res) {
        document.getElementById('qrcode').innerHTML = '';
        new _qrcodejs.default('qrcode', {
          width: 150,
          height: 150,
          text: res.wx_qrcode_url
        });
      });
    },
    /**
     * 提交设置
     */
    postEdit: function postEdit() {
      var _this3 = this;
      this.$post('agentapi/system/save_key_value', this.form).then(function (res) {
        _this3.$message({
          message: '设置成功',
          type: 'success'
        });
      });
    }
  }
};